import { defineLazyComponent } from "@/components/defineLazyComponent";

/**
 * Async-loaded wrapper around WysiwygEditor.vue, which pulls in tiptap.
 * Always import this instead of WysiwygEditor.vue directly, so the editor
 * library stays in its own chunk and isn't included in the main bundle.
 */
export const WysiwygEditorAsync = defineLazyComponent(
  () => import("./WysiwygEditor.vue"),
);
